import { render, staticRenderFns } from "./AppointmentInfo.vue?vue&type=template&id=3f0187e7&scoped=true&"
import script from "./AppointmentInfo.vue?vue&type=script&lang=ts&"
export * from "./AppointmentInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentInfo.vue?vue&type=style&index=0&id=3f0187e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0187e7",
  null
  
)

export default component.exports